import {
  CategoryPageDestinationOptionsResponseSchema,
  WebsiteCategoryPageDetailSchema,
  WebsiteCategoryPageListResponseSchema,
  type CategoryPageDestinationOptionsResponse,
  type CreateWebsiteCategoryPageRequest,
  type UpdateWebsiteCategoryPageRequest,
  type WebsiteCategoryPageDetail,
  type WebsiteCategoryPageListQuery,
  type WebsiteCategoryPageListResponse,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

const BASE = '/admin/website/category-pages';

export const list = async (
  query: WebsiteCategoryPageListQuery,
): Promise<WebsiteCategoryPageListResponse> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return WebsiteCategoryPageListResponseSchema.parse(data);
};

export const get = async (id: string): Promise<WebsiteCategoryPageDetail> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${id}`);
  return WebsiteCategoryPageDetailSchema.parse(data);
};

/** Rows for the "Sorting" tab - the page's destination tiles in display order. */
export const listDestinationOptions = async (
  id: string,
): Promise<CategoryPageDestinationOptionsResponse> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${id}/destination-options`);
  return CategoryPageDestinationOptionsResponseSchema.parse(data);
};

export const create = async (
  payload: CreateWebsiteCategoryPageRequest,
): Promise<WebsiteCategoryPageDetail> => {
  const { data } = await apiClient.post<unknown>(BASE, payload);
  return WebsiteCategoryPageDetailSchema.parse(data);
};

export const update = async (
  id: string,
  payload: UpdateWebsiteCategoryPageRequest,
): Promise<WebsiteCategoryPageDetail> => {
  const { data } = await apiClient.patch<unknown>(`${BASE}/${id}`, payload);
  return WebsiteCategoryPageDetailSchema.parse(data);
};

export const remove = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

export const publish = async (id: string): Promise<WebsiteCategoryPageDetail> => {
  const { data } = await apiClient.post<unknown>(`${BASE}/${id}/publish`);
  return WebsiteCategoryPageDetailSchema.parse(data);
};

export const unpublish = async (id: string): Promise<WebsiteCategoryPageDetail> => {
  const { data } = await apiClient.post<unknown>(`${BASE}/${id}/unpublish`);
  return WebsiteCategoryPageDetailSchema.parse(data);
};
